import type {
  GetListResponseOfNotificationSimpleResponse,
  GetNotificationListRequest,
} from 'src/api/ProactApiClient';
import {notificationApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const notificationApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getNotificationList: builder.query<
      GetListResponseOfNotificationSimpleResponse,
      GetNotificationListRequest
    >({
      queryFn: clientQuery(params => notificationApiClient.list(params)),
      providesTags: ['Notifications'],
    }),
  }),
});

export const {useGetNotificationListQuery} = notificationApi;
